/* eslint-disable camelcase */
import { find, toInteger } from "lodash";

// code uses ISO 639-1
export const languages = [
  { code: "en", en_name: "English", native_name: "" },
  { code: "tl", en_name: "Tagalog", native_name: "Wikang Tagalog" },
  { code: "vi", en_name: "Vietnamese", native_name: "Tiếng Việt" },
  { code: "zh", en_name: "Chinese", native_name: "中文" },
  { code: "es", en_name: "Spanish", native_name: "Español" },
  { code: "ar", en_name: "Arabic", native_name: "العربية" },
  { code: "fa", en_name: "Farsi", native_name: "فارسی" },
];

export const getLanguageNameByCode = (code: string): string | null => {
  const lang = find(languages, (x) => x.code === code);
  return lang ? lang.en_name : null;
};

export const formatAsCurrency = (number: string): string => {
  const formatter = new Intl.NumberFormat("us-US", { style: "currency", currency: "USD", maximumSignificantDigits: 3 });
  return formatter.format(toInteger(number));
};
